import {apiback} from '../../../../../config';

export default {
    create: function(attributes) {
        const data = new FormData();
        const attrs = attributes;
        for (const item in attrs) {
            data.append(item, attrs[item]);
        }
        return {
            url: apiback('API_CAREER'),
            type: 'POST',
            data: data,
            dataType: 'json',
            contentType: 'application/json'
        };
    }
};
